/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface MissionPlannerServiceControlActionArgs {
  timeoutS: number;
  startMissionPlanningRequest?: MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest | undefined;
  getWaypointForCurrentPoseRequest?:
    | MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest
    | undefined;
  cancelMissionPlanningSessionRequest?:
    | MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest
    | undefined;
}

export interface MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest {
  json: string;
}

export interface MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest {
  json: string;
}

export interface MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest {
  json: string;
}

export interface MissionPlannerServiceControlResultData {
  startMissionPlanningResponse?: MissionPlannerServiceControlResultData_StartMissionPlanningResponse | undefined;
  getWaypointForCurrentPoseResponse?:
    | MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse
    | undefined;
  cancelMissionPlanningSessionResponse?:
    | MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse
    | undefined;
}

export interface MissionPlannerServiceControlResultData_StartMissionPlanningResponse {
  json: string;
}

export interface MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse {
  json: string;
}

export interface MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse {
  json: string;
}

export interface MissionPlannerServiceControlActionStateData {
}

function createBaseMissionPlannerServiceControlActionArgs(): MissionPlannerServiceControlActionArgs {
  return {
    timeoutS: 0,
    startMissionPlanningRequest: undefined,
    getWaypointForCurrentPoseRequest: undefined,
    cancelMissionPlanningSessionRequest: undefined,
  };
}

export const MissionPlannerServiceControlActionArgs = {
  encode(message: MissionPlannerServiceControlActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeoutS !== 0) {
      writer.uint32(13).float(message.timeoutS);
    }
    if (message.startMissionPlanningRequest !== undefined) {
      MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest.encode(
        message.startMissionPlanningRequest,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    if (message.getWaypointForCurrentPoseRequest !== undefined) {
      MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest.encode(
        message.getWaypointForCurrentPoseRequest,
        writer.uint32(26).fork(),
      ).ldelim();
    }
    if (message.cancelMissionPlanningSessionRequest !== undefined) {
      MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest.encode(
        message.cancelMissionPlanningSessionRequest,
        writer.uint32(34).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionPlannerServiceControlActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionPlannerServiceControlActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.startMissionPlanningRequest = MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest
            .decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.getWaypointForCurrentPoseRequest =
            MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.cancelMissionPlanningSessionRequest =
            MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionPlannerServiceControlActionArgs {
    return {
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0,
      startMissionPlanningRequest: isSet(object.startMissionPlanningRequest)
        ? MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest.fromJSON(
          object.startMissionPlanningRequest,
        )
        : undefined,
      getWaypointForCurrentPoseRequest: isSet(object.getWaypointForCurrentPoseRequest)
        ? MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest.fromJSON(
          object.getWaypointForCurrentPoseRequest,
        )
        : undefined,
      cancelMissionPlanningSessionRequest: isSet(object.cancelMissionPlanningSessionRequest)
        ? MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest.fromJSON(
          object.cancelMissionPlanningSessionRequest,
        )
        : undefined,
    };
  },

  toJSON(message: MissionPlannerServiceControlActionArgs): unknown {
    const obj: any = {};
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    if (message.startMissionPlanningRequest !== undefined) {
      obj.startMissionPlanningRequest = MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest.toJSON(
        message.startMissionPlanningRequest,
      );
    }
    if (message.getWaypointForCurrentPoseRequest !== undefined) {
      obj.getWaypointForCurrentPoseRequest = MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest
        .toJSON(message.getWaypointForCurrentPoseRequest);
    }
    if (message.cancelMissionPlanningSessionRequest !== undefined) {
      obj.cancelMissionPlanningSessionRequest =
        MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest.toJSON(
          message.cancelMissionPlanningSessionRequest,
        );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionPlannerServiceControlActionArgs>, I>>(
    base?: I,
  ): MissionPlannerServiceControlActionArgs {
    return MissionPlannerServiceControlActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionPlannerServiceControlActionArgs>, I>>(
    object: I,
  ): MissionPlannerServiceControlActionArgs {
    const message = createBaseMissionPlannerServiceControlActionArgs();
    message.timeoutS = object.timeoutS ?? 0;
    message.startMissionPlanningRequest =
      (object.startMissionPlanningRequest !== undefined && object.startMissionPlanningRequest !== null)
        ? MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest.fromPartial(
          object.startMissionPlanningRequest,
        )
        : undefined;
    message.getWaypointForCurrentPoseRequest =
      (object.getWaypointForCurrentPoseRequest !== undefined && object.getWaypointForCurrentPoseRequest !== null)
        ? MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest.fromPartial(
          object.getWaypointForCurrentPoseRequest,
        )
        : undefined;
    message.cancelMissionPlanningSessionRequest =
      (object.cancelMissionPlanningSessionRequest !== undefined && object.cancelMissionPlanningSessionRequest !== null)
        ? MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest.fromPartial(
          object.cancelMissionPlanningSessionRequest,
        )
        : undefined;
    return message;
  },
};

function createBaseMissionPlannerServiceControlActionArgs_StartMissionPlanningRequest(): MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest {
  return { json: "" };
}

export const MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest = {
  encode(
    message: MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.json !== "") {
      writer.uint32(10).string(message.json);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionPlannerServiceControlActionArgs_StartMissionPlanningRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.json = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest {
    return { json: isSet(object.json) ? globalThis.String(object.json) : "" };
  },

  toJSON(message: MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest): unknown {
    const obj: any = {};
    if (message.json !== "") {
      obj.json = message.json;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest>, I>>(
    base?: I,
  ): MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest {
    return MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest>, I>>(
    object: I,
  ): MissionPlannerServiceControlActionArgs_StartMissionPlanningRequest {
    const message = createBaseMissionPlannerServiceControlActionArgs_StartMissionPlanningRequest();
    message.json = object.json ?? "";
    return message;
  },
};

function createBaseMissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest(): MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest {
  return { json: "" };
}

export const MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest = {
  encode(
    message: MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.json !== "") {
      writer.uint32(10).string(message.json);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.json = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest {
    return { json: isSet(object.json) ? globalThis.String(object.json) : "" };
  },

  toJSON(message: MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest): unknown {
    const obj: any = {};
    if (message.json !== "") {
      obj.json = message.json;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest>, I>>(
    base?: I,
  ): MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest {
    return MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest>, I>>(
    object: I,
  ): MissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest {
    const message = createBaseMissionPlannerServiceControlActionArgs_GetWaypointForCurrentPoseRequest();
    message.json = object.json ?? "";
    return message;
  },
};

function createBaseMissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest(): MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest {
  return { json: "" };
}

export const MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest = {
  encode(
    message: MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.json !== "") {
      writer.uint32(10).string(message.json);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.json = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest {
    return { json: isSet(object.json) ? globalThis.String(object.json) : "" };
  },

  toJSON(message: MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest): unknown {
    const obj: any = {};
    if (message.json !== "") {
      obj.json = message.json;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest>, I>>(
    base?: I,
  ): MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest {
    return MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<
    I extends Exact<DeepPartial<MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest>, I>,
  >(object: I): MissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest {
    const message = createBaseMissionPlannerServiceControlActionArgs_CancelMissionPlanningSessionRequest();
    message.json = object.json ?? "";
    return message;
  },
};

function createBaseMissionPlannerServiceControlResultData(): MissionPlannerServiceControlResultData {
  return {
    startMissionPlanningResponse: undefined,
    getWaypointForCurrentPoseResponse: undefined,
    cancelMissionPlanningSessionResponse: undefined,
  };
}

export const MissionPlannerServiceControlResultData = {
  encode(message: MissionPlannerServiceControlResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.startMissionPlanningResponse !== undefined) {
      MissionPlannerServiceControlResultData_StartMissionPlanningResponse.encode(
        message.startMissionPlanningResponse,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    if (message.getWaypointForCurrentPoseResponse !== undefined) {
      MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse.encode(
        message.getWaypointForCurrentPoseResponse,
        writer.uint32(26).fork(),
      ).ldelim();
    }
    if (message.cancelMissionPlanningSessionResponse !== undefined) {
      MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse.encode(
        message.cancelMissionPlanningSessionResponse,
        writer.uint32(34).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionPlannerServiceControlResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionPlannerServiceControlResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.startMissionPlanningResponse = MissionPlannerServiceControlResultData_StartMissionPlanningResponse
            .decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.getWaypointForCurrentPoseResponse =
            MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.cancelMissionPlanningSessionResponse =
            MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionPlannerServiceControlResultData {
    return {
      startMissionPlanningResponse: isSet(object.startMissionPlanningResponse)
        ? MissionPlannerServiceControlResultData_StartMissionPlanningResponse.fromJSON(
          object.startMissionPlanningResponse,
        )
        : undefined,
      getWaypointForCurrentPoseResponse: isSet(object.getWaypointForCurrentPoseResponse)
        ? MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse.fromJSON(
          object.getWaypointForCurrentPoseResponse,
        )
        : undefined,
      cancelMissionPlanningSessionResponse: isSet(object.cancelMissionPlanningSessionResponse)
        ? MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse.fromJSON(
          object.cancelMissionPlanningSessionResponse,
        )
        : undefined,
    };
  },

  toJSON(message: MissionPlannerServiceControlResultData): unknown {
    const obj: any = {};
    if (message.startMissionPlanningResponse !== undefined) {
      obj.startMissionPlanningResponse = MissionPlannerServiceControlResultData_StartMissionPlanningResponse.toJSON(
        message.startMissionPlanningResponse,
      );
    }
    if (message.getWaypointForCurrentPoseResponse !== undefined) {
      obj.getWaypointForCurrentPoseResponse = MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse
        .toJSON(message.getWaypointForCurrentPoseResponse);
    }
    if (message.cancelMissionPlanningSessionResponse !== undefined) {
      obj.cancelMissionPlanningSessionResponse =
        MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse.toJSON(
          message.cancelMissionPlanningSessionResponse,
        );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionPlannerServiceControlResultData>, I>>(
    base?: I,
  ): MissionPlannerServiceControlResultData {
    return MissionPlannerServiceControlResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionPlannerServiceControlResultData>, I>>(
    object: I,
  ): MissionPlannerServiceControlResultData {
    const message = createBaseMissionPlannerServiceControlResultData();
    message.startMissionPlanningResponse =
      (object.startMissionPlanningResponse !== undefined && object.startMissionPlanningResponse !== null)
        ? MissionPlannerServiceControlResultData_StartMissionPlanningResponse.fromPartial(
          object.startMissionPlanningResponse,
        )
        : undefined;
    message.getWaypointForCurrentPoseResponse =
      (object.getWaypointForCurrentPoseResponse !== undefined && object.getWaypointForCurrentPoseResponse !== null)
        ? MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse.fromPartial(
          object.getWaypointForCurrentPoseResponse,
        )
        : undefined;
    message.cancelMissionPlanningSessionResponse =
      (object.cancelMissionPlanningSessionResponse !== undefined &&
          object.cancelMissionPlanningSessionResponse !== null)
        ? MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse.fromPartial(
          object.cancelMissionPlanningSessionResponse,
        )
        : undefined;
    return message;
  },
};

function createBaseMissionPlannerServiceControlResultData_StartMissionPlanningResponse(): MissionPlannerServiceControlResultData_StartMissionPlanningResponse {
  return { json: "" };
}

export const MissionPlannerServiceControlResultData_StartMissionPlanningResponse = {
  encode(
    message: MissionPlannerServiceControlResultData_StartMissionPlanningResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.json !== "") {
      writer.uint32(10).string(message.json);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): MissionPlannerServiceControlResultData_StartMissionPlanningResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionPlannerServiceControlResultData_StartMissionPlanningResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.json = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionPlannerServiceControlResultData_StartMissionPlanningResponse {
    return { json: isSet(object.json) ? globalThis.String(object.json) : "" };
  },

  toJSON(message: MissionPlannerServiceControlResultData_StartMissionPlanningResponse): unknown {
    const obj: any = {};
    if (message.json !== "") {
      obj.json = message.json;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionPlannerServiceControlResultData_StartMissionPlanningResponse>, I>>(
    base?: I,
  ): MissionPlannerServiceControlResultData_StartMissionPlanningResponse {
    return MissionPlannerServiceControlResultData_StartMissionPlanningResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionPlannerServiceControlResultData_StartMissionPlanningResponse>, I>>(
    object: I,
  ): MissionPlannerServiceControlResultData_StartMissionPlanningResponse {
    const message = createBaseMissionPlannerServiceControlResultData_StartMissionPlanningResponse();
    message.json = object.json ?? "";
    return message;
  },
};

function createBaseMissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse(): MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse {
  return { json: "" };
}

export const MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse = {
  encode(
    message: MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.json !== "") {
      writer.uint32(10).string(message.json);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.json = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse {
    return { json: isSet(object.json) ? globalThis.String(object.json) : "" };
  },

  toJSON(message: MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse): unknown {
    const obj: any = {};
    if (message.json !== "") {
      obj.json = message.json;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse>, I>>(
    base?: I,
  ): MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse {
    return MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<
    I extends Exact<DeepPartial<MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse>, I>,
  >(object: I): MissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse {
    const message = createBaseMissionPlannerServiceControlResultData_GetWaypointForCurrentPoseResponse();
    message.json = object.json ?? "";
    return message;
  },
};

function createBaseMissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse(): MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse {
  return { json: "" };
}

export const MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse = {
  encode(
    message: MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.json !== "") {
      writer.uint32(10).string(message.json);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.json = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse {
    return { json: isSet(object.json) ? globalThis.String(object.json) : "" };
  },

  toJSON(message: MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse): unknown {
    const obj: any = {};
    if (message.json !== "") {
      obj.json = message.json;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse>, I>>(
    base?: I,
  ): MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse {
    return MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<
    I extends Exact<DeepPartial<MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse>, I>,
  >(object: I): MissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse {
    const message = createBaseMissionPlannerServiceControlResultData_CancelMissionPlanningSessionResponse();
    message.json = object.json ?? "";
    return message;
  },
};

function createBaseMissionPlannerServiceControlActionStateData(): MissionPlannerServiceControlActionStateData {
  return {};
}

export const MissionPlannerServiceControlActionStateData = {
  encode(_: MissionPlannerServiceControlActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionPlannerServiceControlActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionPlannerServiceControlActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): MissionPlannerServiceControlActionStateData {
    return {};
  },

  toJSON(_: MissionPlannerServiceControlActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionPlannerServiceControlActionStateData>, I>>(
    base?: I,
  ): MissionPlannerServiceControlActionStateData {
    return MissionPlannerServiceControlActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionPlannerServiceControlActionStateData>, I>>(
    _: I,
  ): MissionPlannerServiceControlActionStateData {
    const message = createBaseMissionPlannerServiceControlActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
